// extracted by mini-css-extract-plugin
var _1 = "bgImage__Y7xiN";
var _2 = "bottomBlock__E6GF9";
var _3 = "bullet__v6_ym";
var _4 = "content__hwyHf";
var _5 = "headerBackground__LpUxJ";
var _6 = "headerBlock__qbbZM";
var _7 = "headerContent__znafT";
var _8 = "image__hK_j9";
var _9 = "imageHolder__PD0I7";
var _a = "section__HRyPs";
var _b = "topBlock__Rgdta";
export { _1 as "bgImage", _2 as "bottomBlock", _3 as "bullet", _4 as "content", _5 as "headerBackground", _6 as "headerBlock", _7 as "headerContent", _8 as "image", _9 as "imageHolder", _a as "section", _b as "topBlock" }
export default { "bgImage": _1, "bottomBlock": _2, "bullet": _3, "content": _4, "headerBackground": _5, "headerBlock": _6, "headerContent": _7, "image": _8, "imageHolder": _9, "section": _a, "topBlock": _b }
